import { CheckoutAddPaymentInfoApplicationEvent
} from '~shared/modules/application-event/models/checkout-add-payment-info-event.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';
export class GaTrackingAddPaymentInfoEventModel implements GATrackingEvent{
  constructor(private checkoutAddPaymentInfoApplicationEventPayload: CheckoutAddPaymentInfoApplicationEvent) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AddPaymentInfo;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.checkoutAddPaymentInfoApplicationEventPayload
      }
    };
  }
}
